import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { KundeninfoLeisteComponent } from '@softapps/fibu/core';
import { backNavigation, BottomTabConfig } from '@softline/application';
import { Store } from '@softline/core';
import { UiCoreModule } from '@softline/ui-core';
import { map } from 'rxjs';
import { Customer } from '../../data/customer';

import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { OffenePostenWidgetComponent } from '@softapps/fibu/offene-posten';
import { KreditlimitWidgetComponent } from '@softapps/wws/kreditlimit';
import { UmsatzstatistikWidgetComponent } from '@softapps/wws/umsatzstatistik';

@Component({
  selector: 'soft-kundenabfrage-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    UiCoreModule,
    KundeninfoLeisteComponent,
    OffenePostenWidgetComponent,
    KreditlimitWidgetComponent,
    UmsatzstatistikWidgetComponent,
  ],
})
export class CustomerDetailComponent {
  /*
  bottomTabs = computed(() => {
    const config: BottomTabConfig[] = [];

    if (this.breakpoint === null) {
      config.push(
        ...[
          {
            name: 'kontoinfo',
            icon: 'fa-light fa-user',
            title: 'Informationen',
          },
          {
            name: 'kreditlimit',
            icon: 'fa-light fa-credit-card',
            title: 'Kreditlimit',
          },
          {
            name: 'umsatz',
            icon: 'fa-light fa-chart-mixed-up-circle-dollar',
            title: 'Umsatzstatistik',
          },
          {
            name: 'offene-posten',
            icon: 'fa-light fa-file-invoice-dollar',
            title: 'Offene Posten',
          },
        ]
      );
    }

    return config;
  });
  */

  public GOOGLE_LINK = 'https://www.google.com/maps/place/';

  private readonly id = toSignal(
    this.activatedRoute.paramMap.pipe(
      map((o) => o.get('id') as string),
      map((id) => (id && !isNaN(+id) ? +id : null))
    )
  );

  readonly kundennummer = toSignal(
    this.activatedRoute.queryParamMap.pipe(map((o) => o.get('nummer')))
  );

  readonly idktostamm = computed(() => {
    return this.id() ?? null;
  });

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly store: Store
  ) {
    backNavigation('/kundenabfrage');
  }

  getGoogleLink(customer: Customer) {
    this.GOOGLE_LINK += customer.strasse ? customer.strasse + ',' : '';
    this.GOOGLE_LINK += customer.strassenr ? customer.strassenr + ',' : '';
    this.GOOGLE_LINK += customer.plz ? customer.plz + ',' : '';
    this.GOOGLE_LINK += customer.ort ? customer.ort + ',' : '';
    return this.GOOGLE_LINK.slice(0, -1);
  }
}
